import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react'
import 'altcha'

 export const Altcha = forwardRef(({ onStateChange }, ref) => {
  const widgetRef = useRef(null)
  const [value, setValue] = useState(null)

  useImperativeHandle(ref, () => ({
    get value() {
      return value
    }
  }), [value])

  useEffect(() => {
    const handleStateChange = (ev) => {
      if ('detail' in ev) {
        setValue(ev.detail.payload || null)
        if (onStateChange) {
          onStateChange(ev)
        }
      }
    }

    const current = widgetRef.current

    if (current) {
      current.addEventListener('statechange', handleStateChange)
      return () => current.removeEventListener('statechange', handleStateChange)
    }
  }, [onStateChange])

  return (
    <altcha-widget
      ref={widgetRef}
      style={{
        '--altcha-max-width': '100%',
      }}
      debug
      test
    ></altcha-widget>
  )
})



